<template>
    <div>
        <b-form @submit.prevent="saveVersion()" data-vv-scope="formVersion">
            <b-row>
                <b-col md="6">
                    <b-form-group>
                        <label>Fecha de publicación <span class="text-danger">*</span></label>
                        <b-form-input v-model="version.date_of_publication" name="date_of_publication" type="date"
                            class="form-control" v-validate="'required'" :max="currentDate" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formVersion.date_of_publication')" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label>Edición <span class="text-danger">*</span></label>
                        <b-form-input v-model="version.version" type="number" class="form-control" name="version"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formVersion.version')" />
                    </b-form-group>
                </b-col>

              <b-col md="12">
                <b-form-group>
                  <label>Sustancias no peligrosas <span class="text-danger">*</span></label>
                  <el-select v-model="version.subs_not_dangers" clearable filterable multiple
                             size="medium" placeholder="Seleccionar frases no peligrosas"
                             name="subs_not_dangers" v-validate="'required'"
                             data-vv-as=" ">
                    <el-option v-for="item in subsNotDangers" :key="item.id"
                               :label="item.name" :value="item.id" />
                  </el-select>
                  <span class="text-danger small"
                        v-text="errors.first('formVersion.subs_not_dangers')" />
                </b-form-group>
              </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Seleccionar países <span class="text-danger">*</span></label>
                        <el-select v-model="version.countries" clearable filterable multiple
                            size="medium" placeholder="Seleccionar países" name="countries"
                            v-validate="'required'" data-vv-as=" ">
                            <el-option v-for="item in countriesWithConfig" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                       
                        <small class="text-muted">
                            Asocia de la edición actual con países. 
                        </small>
                       <div class="">
                        <span class="text-danger small" v-text="errors.first('formVersion.countries')" /></div>
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <div class="d-flex align-items-center">
                            <el-switch
                                v-model="version.is_main"
                                :active-value="1"
                                :inactive-value="0"
                                active-text="Edición Principal"
                                active-color="#87CEEB"
                                inactive-color="">
                            </el-switch>
                        </div>
                       
                        <div v-if="version.is_main === 1" class="alert alert-warning mt-2" role="alert">
                            <i class="fa fa-exclamation-triangle"></i>
                            <strong> Advertencia:</strong> Si hay otra edición marcada como principal, solo quedará esta edición como principal en el sistema.
                        </div>
                    </b-form-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelVersion">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import moment from "moment";
export default {
    name: 'FormVersions',
    data() {
        return {
            currentDate: moment().format('YYYY-MM-DD')
        }
    },

    async created(){
      await this.getSubNotDangers();
      await this.getCountriesWithConfig();
      // Asegurar que is_main sea un número cuando se carga el componente
      if (this.version.is_main !== undefined && this.version.is_main !== null) {
          this.version.is_main = parseInt(this.version.is_main);
      }
    },

    computed: {
        ...mapState('sgaVersions', ['version', 'action', 'subsNotDangers']),
        ...mapState('countries', ['countriesWithConfig']),
    },

    watch: {
        'version.countries'(val) {
            if (Array.isArray(val) && val.length > 1) {
                this.version.countries = [val[val.length - 1]];
            }
        },
        'action'(newAction) {
            // Establecer is_main como 1 por defecto tanto al crear como editar
            if (newAction === 'create' || newAction === 'edit') {
                this.$nextTick(() => {
                    if (this.version.is_main === undefined || this.version.is_main === null) {
                        this.version.is_main = 1;
                    }
                });
            }
        },
        'version.is_main'(val) {
            // Asegurar que is_main sea siempre un número
            if (val !== undefined && val !== null) {
                this.version.is_main = parseInt(val);
            }
        }
    },

    methods: {

        ...mapActions('countries', [ 'getCountriesWithConfig']),
        ...mapActions('sgaVersions', ['createVersionSga', 'getVersionsSga', 'getActiveVersionsSga', 'updateVersionSga', 'getSubNotDangers']),

        ...mapMutations('sgaVersions', ['setDefaultVersionSga']),

        cancelVersion() {
            this.setDefaultVersionSga();
            this.$bvModal.hide('modal_create_versions');
        },

        async cancelAndGetVersions() {
            this.cancelVersion();
            await this.getVersionsSga();
            await this.getActiveVersionsSga();
        },

        async saveVersion() {
            const isValid = await this.$validator.validateAll('formVersion');
            if (!isValid) return;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateVersionSga(this.version);
            } else {
                flag = await this.createVersionSga(this.version);
            }

            if (flag) {
                this.cancelAndGetVersions();
            }
        }
    }
}
</script>
